// Admin console entry point.
//
// Registering <admin-app> triggers the import chain for the shell, the users
// page, the admin API client, and the reused firewall-safe <login-page>.
//
// As in the decks app's main.ts we kick off the memoised Firebase Auth loader
// WITHOUT awaiting it, so the session resolves in parallel with the rest of the
// boot; the later `await getFirebaseAuth()` in the shell gate + the admin-api
// Bearer helper hit the same in-flight promise.
import { getFirebaseAuth } from '../src/lib/firebase';
void getFirebaseAuth();

// Bundle the Paper Design System tokens FIRST so the admin chrome (and the
// reused login-page) have real values for every var(--…). The decks app loads
// these as <link>s served by its Go backend, but admin.rdx.tools is a separate
// Firebase Hosting site whose only backend rewrite is /api/**; importing the
// token files here lets Vite bundle them into dist-admin so the admin site is
// fully self-contained and never 404s on /src/*. Imported in the same order as
// the decks index.html: deck-tokens (core Paper tokens + light/dark flips),
// then tokens (the V2 Ricoh Paper themes incl. --error-soft / --brand-primary).
import '../../src/deck-tokens.css';
import '../../src/tokens.css';

// Admin-only chrome on top of the tokens — table, topbar, modals. Tokens only.
import './admin.css';

import './admin-app';
